module.exports = function getResource(label) {
    const resources = {
        sameDayDelivery: 'Livraison le jour même ',
        standard: 'Standard ',
        item: 'Article',
        items: 'Articles'
    };

    return resources[label];
};
